import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const SEARCH_PARAM_SHIP_ID = 'shipId'

export const availabilityPlanningSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_SHIP_ID]: z.string().optional(),
})
